import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  hideModalVerifyOtp,
  onChangeVerifyOtp,
  onClickSendOtp,
} from 'actions/setting/bankAccount';
import { getFormValues } from 'redux-form';
import styles from './style.css';

class VerifyOtpModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: 59,
    };
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      const { seconds } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  render() {
    const {
      showModalVerifyOtp,
      showLoadingSpinnerModal,
      profile,
      otp,
    } = this.props;
    const { seconds } = this.state;
    const otpTriesLeft = 3 - otp.errorCount;

    return (
      <Modal
        show={showModalVerifyOtp}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="pull-left">Verification Code</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showLoadingSpinnerModal ? (
            <div className={`${styles['loading-spinner']}`}>
              <img src={require('assets/images/loading-simple.gif')} />
            </div>
          ) : (
            <div>
              <p>
                Please enter the OTP sent via SMS to{' '}
                <strong>{this._censorPhoneNumber(profile.phone)}</strong> to
                verify your identity and save your changes
              </p>

              <div className={`${styles['div-otp']}`}>
                <div className={`${styles['div-otp-inner']}`}>
                  <input
                    type="text"
                    className={
                      otpTriesLeft < 3
                        ? `${styles['input-otp-error']}`
                        : `${styles['input-otp']}`
                    }
                    maxLength="6"
                    onChange={this._onChangeOtp}
                  />
                </div>
              </div>

              <p className={`${styles['text-error-otp']}`}>
                {otpTriesLeft <= 0
                  ? 'You have 0 tries left. Please resend a new code.'
                  : otpTriesLeft < 3
                  ? `Enter a valid verification code. You have ${otpTriesLeft} tries left.`
                  : ''}
              </p>

              <div className={`${styles['div-otp-resend']}`}>
                <a
                  onClick={this._onClickResendOtp}
                  className={seconds > 0 && `${styles.disabled}`}
                >
                  Resend OTP
                </a>{' '}
                {seconds > 0 && `(${seconds}s)`}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            className={`btn mr-10px ${styles['btn-outline-dark']} ${
              styles['btn-large']
            }`}
            type="button"
            onClick={this._onClickCancel}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickCancel = e => {
    this.props.dispatch(hideModalVerifyOtp());
    e.preventDefault();
    e.stopPropagation();
  };

  _onChangeOtp = e => {
    const { bankAccountForm, otp, profile, rightColumnType } = this.props;
    const code = e.target.value;

    if (code.length === 6 && otp.errorCount < 3) {
      this.props.dispatch(
        onChangeVerifyOtp(otp, code, bankAccountForm, rightColumnType, profile)
      );
    }
  };

  _onClickResendOtp = () => {
    const { profile } = this.props;
    this.props.dispatch(onClickSendOtp(profile.phone));
    this.setState({
      seconds: 59,
    });
  };

  _censorPhoneNumber = phoneNumber => {
    const preStr = phoneNumber.substring(0, 3);
    const postStr = phoneNumber.substring(11);
    return `${preStr}********${postStr}`;
  };
}

function mapStateToProps(state) {
  const {
    otp,
    profile,
    rightColumnType,
    showModalVerifyOtp,
    showLoadingSpinnerModal,
  } = state.setting.bankAccount;

  return {
    otp,
    profile,
    rightColumnType,
    showModalVerifyOtp,
    showLoadingSpinnerModal,
    bankAccountForm: getFormValues('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyOtpModal);
